
/**
 * 延迟执行, 防止短时间内频繁执行
 * @constructor
 */
let Delay = function () {
  this.timer = null
}
Delay.prototype = {
  run: function (fun, timeDelay) {
    let self = this
    if (self.timer) {
      window.clearTimeout (self.timer)
    }
    self.timer = window.setTimeout (fun, timeDelay)
  }
}

/**
 * deferred
 * @constructor
 * @example
 * deferredObject.done(function(){...})[.fail(function(){...})]
 */
function Deferred() {
  this._done = []
  this._fail = []
}

Deferred.prototype = {
  execute: function (list, args) {
    let i = list.length
    args = Array.prototype.slice.call (args)
    while (i--) list[ i ].apply (null, args)
  },
  resolve: function () {
    this.execute (this._done, arguments)
  },
  reject: function () {
    this.execute (this._fail, arguments)
  },
  done: function (callback) {
    this._done.push (callback)
    return this
  },
  fail: function (callback) {
    this._fail.push (callback)
    return this
  },
  onOk: function (callback) {
    return this.done (callback)
  },
  onCancel: function (callback) {
    return this.fail (callback)
  }
}

export default {
  go: function (path) {
    // browserHistory.push (path)
  },
  Delay: Delay,
  Deferred: Deferred,
  serializeParam: function (param) {
    let paramString = []
    for (let k in param) {
      paramString.push ([ k, param[ k ] ].join ('='))
    }
    return paramString.join ('&')
  },
  /**
   * 类型判断
   * @param obj
   * @returns {string}
   */
  typeOf: function (obj) {
    return {}.toString.call (obj).split (' ')[ 1 ].slice (0, -1).toLowerCase ();
  },

  /**
   * 根据窗口宽度计算字体大小
   * @param min
   * @param max
   * @returns {number}
   */
  getResizeFontSize: function (min, max) {
    let width = document.body.offsetWidth
    if (width > max) {
      width = max
    }
    return width / 10
  },
  /**
   * 数字增加千分号
   * @param data
   */
  dataWithComma: function (data) {
    if (!data) {
      return 0
    }
    var reg = /(\d{1,3})(?=(\d{3})+(\.\d*)?$)/g
    var num = data + ''
    return num.replace (reg, '$1,')
  },
  ISO8601: function (time) {
    return time.format ().replace (/:(\d{2})$/, '$1')
  }
}



// WEBPACK FOOTER //
// ./src/util/util.js